// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_my-0";